module.exports = __webpack_public_path__ + "img/icon_map_100_on.009bc3b3.png";